// 直接 export import 的內容
// import 資料夾名稱的時候會從目標資料夾底下的index.js檔案中找內容

// 有需要一次全取得時，使用 import * 的方式即可
// 可用 import * as xxx 的方式命名完整的物件
// as 別名的用法有點缺乏一致性，只有import * 的時候是直接用as
// 但import * 以外的狀況，必須包在 {} 之中，例如 import { xxx as xxx}
export { default as HOCLanguageInjector } from './HOCLanguageInjector';
export { default as formAppendMultiple } from './formAppendMultiple';
// export { default as stringComparing } from './stringComparing';


// WEBPACK FOOTER //
// ./src/helpers/index.js